import { createFileRoute } from '@tanstack/react-router';

import { InvoicePaymentLinkGenerator } from '../modules/Invoice/components/InvoicePaymentLinkGenerator';

export const Route = createFileRoute('/test-payment-link/$invoiceId')({
  component: RouteComponent,
});

function RouteComponent() {
  const { invoiceId } = Route.useParams();

  return (
    <div className="min-h-screen bg-gray-50 p-8">
      <div className="mx-auto max-w-2xl">
        <h1 className="mb-6 text-3xl font-bold text-gray-900">Test Payment Link Generator</h1>
        <p className="mb-6 text-gray-600">
          Use this page to generate a payment link for testing. The link will direct customers to a
          secure payment page where they can pay their invoice.
        </p>

        <InvoicePaymentLinkGenerator invoiceId={Number(invoiceId)} />

        <div className="mt-6 rounded-lg border border-blue-200 bg-blue-50 p-4">
          <h3 className="mb-2 font-semibold text-blue-900">Testing Instructions:</h3>
          <ol className="list-inside list-decimal space-y-2 text-sm text-blue-800">
            <li>Enter the number of days until the link expires (default: 30 days)</li>
            <li>Click &quot;Generate Payment Link&quot; to create a secure payment token</li>
            <li>Copy the generated payment URL</li>
            <li>Open the URL in an incognito window or different browser to test</li>
            <li>Complete the payment flow using Stripe test card numbers</li>
          </ol>
        </div>

        <div className="mt-4 rounded-lg border border-gray-200 bg-white p-4">
          <h3 className="mb-2 font-semibold text-gray-900">Stripe Test Cards:</h3>
          <div className="space-y-2 text-sm text-gray-700">
            <div>
              <strong>Success:</strong> 4242 4242 4242 4242
            </div>
            <div>
              <strong>Decline:</strong> 4000 0000 0000 0002
            </div>
            <div>
              <strong>3D Secure:</strong> 4000 0025 0000 3155
            </div>
            <div className="text-xs text-gray-500">
              Use any future expiration date, any 3-digit CVC, and any ZIP code
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
